import { observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { Container } from 'reactstrap';

import MyAccountThankYouPageContent from '../../components/checkout/confirmation/MyAccountThankYouPageContent';
import RobotsMeta from '../../components/head/RobotsMeta';
import SEOTitle from '../../components/head/SEOTitle';
import GenericLayout from '../../components/layout/GenericLayout';
import Page from '../../components/layout/Page';
import globalTranslations from '../../i18n/globalTranslations';
import CommonPage from '../../types/CommonPage';

@observer
class MyAccountThankYouPage extends Component {
  render() {
    return (
      <Page
        name={CommonPage.MY_ACCOUNT_THANK_YOU}
        className="MyAccountThankYouPage"
      >
        <Container className="MyAccountThankYouPage__container">
          <GenericLayout
            content={
              <Fragment>
                <SEOTitle
                  title={{ ...globalTranslations.successfulPurchasePageTitle }}
                />
                <RobotsMeta noindex />
                <MyAccountThankYouPageContent />
              </Fragment>
            }
          />
        </Container>
      </Page>
    );
  }
}

export default MyAccountThankYouPage;
